<div class="fz-dialog__close" mat-dialog-title>
  <button mat-icon-button (click)="handleClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="editInfoForm" (submit)="handleFormSubmit($event)">
  <div class="fz-dialog">
    <div class="fz-dialog__root">
      <div class="fz-dialog__head">
        <h2 class="fz-dialog__head__title mat-headline-small">
          Edit info and/or provide SSN
        </h2>
        <p class="fz-dialog__head__subtitle">
          Please confirm your details or enter your SSN for verification. Thank
          you for helping us grow our community of real players.
        </p>
      </div>
      <div class="fz-dialog__content">
        <div class="form">
          <!-- First name field -->
          <div class="form-field">
            <fz-form-field-text formControlName="firstName">
              <mat-label>First Name</mat-label>
            </fz-form-field-text>
          </div>

          <!-- Last name field -->
          <div class="form-field">
            <fz-form-field-text formControlName="lastName" [required]="true">
              <mat-label>Last Name</mat-label>
            </fz-form-field-text>
          </div>

          <!-- Date of birth field -->
          <div class="form-field coll--6">
            <fz-form-field-text
              formControlName="dateOfBirth"
              placeholder="MM/DD/YYYY"
              mask="M0/d0/0000"
              [required]="true"
            >
              <mat-label>Date of Birth</mat-label>
            </fz-form-field-text>
          </div>

          <!-- Address field -->
          <div class="form-field coll--6">
            <fz-field-address
              formControlName="address"
              [required]="true"
              [controlErrorAnchor]="anchorFieldAddress"
              [touched]="editInfoForm.get('address')?.touched"
            >
              <label>Address</label>
              <mat-error>
                <ng-template
                  controlErrorAnchor
                  #anchorFieldAddress="controlErrorAnchor"
                ></ng-template>
              </mat-error>
            </fz-field-address>
          </div>

          <!-- SSN field -->
          <div class="form-field coll--6 ssn-field" *ngIf="!TSEVO_DISABLED">
            <div class="optional">
              <p class="mat-body-2">Optional</p>
            </div>
            <fz-form-field-text
              formControlName="ssn"
              [mask]="FULL_SSN_ALLOWED ? '000-00-0000' : '0000'"
              placeholder="{{ FULL_SSN_ALLOWED ? '123-45-6789' : '1234' }}"
            >
              <mat-label>SSN</mat-label>
            </fz-form-field-text>
          </div>
        </div>
      </div>
      <div class="fz-dialog__actions">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="(data.submitting$ | async) === true"
          [ngClass]="{
            'mat-button-loading': (data.submitting$ | async) === true
          }"
        >
          Verify Identity
        </button>
      </div>
    </div>
  </div>
</form>
